import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'premiereLettreMajusculePipe'
})
export class PremiereLettreMajusculePipe implements PipeTransform {
	transform(value: any, attribut?: string): any {
		if (!value || (typeof value !== 'string' && !attribut)) {
			return '';
		}

		if (Array.isArray(value)) {
			return (value as Array<any>).map(item => this.convertir(item, attribut));
		}
		if (typeof value === 'object') {
			return this.convertir(value, attribut);
		}
		return this.convertir(value);
	}

	convertir(valeur: any, attribut?: string) {
		if (attribut) {
			const objet = {...valeur};
			objet[attribut] = this.convertirPremiereLettreMajuscule(valeur[attribut]);
			return objet;
		}
		return this.convertirPremiereLettreMajuscule(valeur);
	}

	convertirPremiereLettreMajuscule(valeur: string) {
		return valeur.toLowerCase().replace(/^(.)|\s(.)/g, function ($1) {
			return $1.toUpperCase();
		});
	}

}
